module.exports = __webpack_public_path__ + "promo/reverb-app-mini-51cc5c894312c9767d00a2e1724a0965.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/reverb-app-mini.svg
// module id = j1ae
// module chunks = 24